
import { useEffect, useState } from "react"
import url from "../api/url"
import { elToast } from "../functions/Alerta"
import { useEmpleadoStore } from "../stores/useEmpleadoStore"

const useHijos = () => {

    // variables
    const objLogueado = useEmpleadoStore(state => state.objLogueado)
    const [necesitaGuarderia, setNecesitaGuarderia] = useState( false )
    const [tieneHijos, setTieneHijos] = useState( false )
    const hijoInicial = {
        funcion: 'guardarHijo',
        edad: '',
        guarderia: '',
        necesitaGuarderia,
        correo: objLogueado.email
    }
    const { URL } = url()
    const [isOpen, setIsOpen] = useState( false )
    const [hijos, setHijos] = useState([])
    const [formHijos, setFormHijos] = useState( hijoInicial )
    const [pk_hijo, setPk_hijo] = useState( 0 )
    const [cargando, setCargando] = useState( false )



    // funciones
    const traerHijos = () => {

        var fd = new FormData()
        fd.append("funcion", "traerHijos")
        fd.append("correo", objLogueado.email)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            setHijos( e )
            if ( e?.length > 0 ) {
                setTieneHijos( true )
            }
        })
        .catch( a => {
            elToast( 'Hay problemas al traer la información de tus hijos', 'error' )
        })
    }


    const guardarHijos = () => {

        setCargando( true )
        fetch( URL, {
            method: 'post',
            body: JSON.stringify({ ...formHijos, pk_hijo })
        })
        .then( res => res.json() )
        .then( function (d) {
            traerHijos()
            if ( d.codigo === 1 && pk_hijo === 0 ) {
                elToast( d.mensaje )
                setFormHijos( hijoInicial )
            } else if ( d.codigo === 0 ) {
                elToast( d.mensaje, 'error' )
            } else if ( d.codigo === 1 ) {
                elToast( d.mensaje )
            }
        })
        .catch( a => {
            elToast( "Error al guardar información.\nPuedes revisar tu conexión o iniciar sesión nuevamente.", 'error' )
        })
        .finally( () => setCargando( false ) )
    }

    const abrirModal = ( borrar_pk = true ) => {
        setIsOpen( true )
        if ( borrar_pk ) {
            setNecesitaGuarderia( false )
            setPk_hijo( 0 )
        }
    }

    const cerrarModal = () => {
        setIsOpen( false )
        setFormHijos( hijoInicial )
    }

    function borrarHijo( pk_hijo ) {
        if ( pk_hijo && window.confirm("El registro será eliminado.") ) {
            fetch( URL, {
                method: 'post',
                body: JSON.stringify({ pk_hijo: pk_hijo, funcion: 'borrarHijo' })
            })
            .then( res => res.json() )
            .then( function (d) {
                if ( d.codigo === 1 ) {
                    traerHijos()
                    elToast( 'Eliminado con éxito' )
                } else {
                    elToast( d.mensaje, 'info' )
                }
            })
            .catch( a => {
                elToast( "Error al eliminar información.\nPuedes revisar tu conexión o iniciar sesión nuevamente.", 'error' )
            })
        }
    }

    function llenarFormHijo( e ) {
        var n;
        if ( e.guarderia.length > 0 ) {
            setNecesitaGuarderia( true )
            n = true
        } else {
            setNecesitaGuarderia( false )
            n = false
        }
        setFormHijos({
            funcion: 'guardarHijo',
            edad: e.edad,
            guarderia: e.guarderia,
            necesitaGuarderia: n,
            correo: objLogueado.email
        })
        setPk_hijo( e.pk_hijo )
        abrirModal( false )
    }


    // useEffects
    useEffect(() => {
        traerHijos()
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        setFormHijos({
            ...formHijos,
            guarderia: '',
            necesitaGuarderia: necesitaGuarderia
        })
        // eslint-disable-next-line
    }, [ necesitaGuarderia ])



    return {
        isOpen, abrirModal, cerrarModal,
        guardarHijos, setFormHijos, formHijos,
        hijos, tieneHijos, setTieneHijos,
        llenarFormHijo, cargando, borrarHijo, necesitaGuarderia, setNecesitaGuarderia,
    }
}

export default useHijos
